import { takeLatest, put, call, fork, select } from 'redux-saga/effects';
import callApi from 'utils/api';
import * as actionTypes from './constants';

import {
  searchSuccess,
  searchFailure,
  searchByTypeSuccess,
  searchByTypeFailure,
  searchValueByTypeSuccess,
  searchValueByTypeFailure,
  searchRelationsSuccess,
  searchRelationsFailure,
  getSearchFiltersSuccess,
  getSearchFiltersFailure,
  shouldRefetch,
} from './search-actions';

export function* doSearch(action) {
  try {
    const { searchValue, filters } = action.payload;
    const pageSize = 6;
    const options = {
      endpoint: `search?pageSize=${pageSize}`,
      options: {
        method: 'POST',
        body: JSON.stringify({
          query: searchValue,
          searchFilters: filters,
        }),
        errorMessage: `Could not fetch search results for ${searchValue}`,
        retryAction: action,
      },
    };
    const results = yield call(callApi, options);
    yield put(shouldRefetch(false));
    yield put(searchSuccess(results));
  } catch (err) {
    yield put(shouldRefetch(false));
    yield put(searchFailure(err));
  }
}

export function* doSearchByType(action) {
  try {
    const { type, searchValue, page, pageSize = 24, filters } = action.payload;
    const options = {
      endpoint: `search/${type}?pageSize=${pageSize}&page=${page}`,
      options: {
        method: 'POST',
        body: JSON.stringify({
          query: searchValue,
          searchFilters: filters,
        }),
        errorMessage: `Could not fetch search results for ${searchValue}`,
        retryAction: action,
      },
    };
    const results = yield call(callApi, options);
    yield put(shouldRefetch(false));
    yield put(searchByTypeSuccess({ results, activePage: action.payload.page }));
  } catch (err) {
    yield put(shouldRefetch(false));
    yield put(searchByTypeFailure(err));
  }
}

const getServiceCenterId = state => state.navigation.navigationSelf.serviceCenterId;

export function* doSearchValueByType(action) {
  try {
    const { searchValue, type, filters = {} } = action.payload;
    const request = {
      query: searchValue,
      filters,
    };
    const serviceCenterId = yield select(getServiceCenterId);
    const results = yield call(callApi, {
      endpoint: `refdata/lookup/${serviceCenterId}/${type}`,
      options: {
        method: 'POST',
        body: JSON.stringify(request),
        errorMessage: `Could not search ${type}`,
        retryAction: action,
      },
    });

    yield put(searchValueByTypeSuccess({ ...results, type }));
  } catch (err) {
    yield put(searchValueByTypeFailure(err));
  }
}

export function* doSearchRelations(action) {
  try {
    const { id } = action.payload;
    const options = {
      endpoint: `relations/${id}`,
      options: {
        errorMessage: `Could not fetch relations for ${id}`,
        retryAction: action,
      },
    };
    const results = yield call(callApi, options);
    yield put(searchRelationsSuccess(results));
  } catch (err) {
    yield put(searchRelationsFailure(err));
  }
}

export function* doGetSearchFilters(action) {
  try {
    const options = {
      endpoint: 'search',
      options: {
        errorMessage: 'Could not fetch search filters',
        retryAction: action,
      },
    };
    const results = yield call(callApi, options);
    yield put(getSearchFiltersSuccess(results));
  } catch (err) {
    yield put(getSearchFiltersFailure(err));
  }
}

function* watchSearch() {
  yield takeLatest(actionTypes.SEARCH_REQUEST, doSearch);
}

function* watchGetSearchFilters() {
  yield takeLatest(actionTypes.SEARCH_FILTERS_REQUEST, doGetSearchFilters);
}

function* watchSearchByType() {
  yield takeLatest(actionTypes.SEARCH_BY_TYPE_REQUEST, doSearchByType);
}

function* watchSearchValueByType() {
  yield takeLatest(actionTypes.SEARCH_VALUE_BY_TYPE_REQUEST, doSearchValueByType);
}

function* watchSearchRelations() {
  yield takeLatest(actionTypes.SEARCH_RELATIONS_REQUEST, doSearchRelations);
}


export default [
  fork(watchSearch),
  fork(watchSearchByType),
  fork(watchSearchValueByType),
  fork(watchSearchRelations),
  fork(watchGetSearchFilters),
];
